import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export function useRejectCancellationRequest(
  options?: UseMutationOptions<unknown, unknown, number, unknown>
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (requestId: number) =>
      axiosInstance
        .post(getAPIURL(`/Admin/Cancellations/${requestId}/Reject`), { confirm: true })
        .then((res) => res.data),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["cancellation-requests"] });
      options?.onSuccess?.(...args);
    },
  });
}
